import angular from "angular";
import { moduleName as recordsModule } from "../../../records";
import { processInstancesObjectConfig } from "./processInstances";

export const vsModuleName = "SlotTrak.Process.objects";

angular
  .module(vsModuleName, [recordsModule])
  .config(processInstancesObjectConfig);
